import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { VideoImageSelector } from 'appSrc/components/Shards';
import Edit from 'appSrc/components/Icons/Edit';
import { Field, reduxForm, Form, change } from 'redux-form';
import { PrimaryButton, DLAutoComplete, DLToggle } from 'appSrc/components/UI';
import { FormTextField, FormTextArea } from 'appSrc/components/UI/ReduxForm';
import { dAPI } from 'appSrc/api';
import { debounce } from 'throttle-debounce';
import style from './styles/style.module.css';

class ReviewForm extends PureComponent {
    constructor( props ) {
        super( props );
        let author = props.initialValues.author || {};
        let video = props.initialValues.video || {};
        let isSponsored = video.isSponsored || false;
        this.state = {
            userSearch: author.displayName || '',
            userOptions: [],
            selectedImage: props.initialValues.image,
            isSponsored: isSponsored,
            showCoverModal: false,
            s3File: props.initialValues.reviewS3File || false,
            vTTS3File: props.initialValues.reviewVTTS3File || false,
            uploading: false,
            uploadingVTT: false,
        };
    }
    updateCover = ( values ) => {
        var imageData = values.selectedImage;
        var ytUrl = values.youtubeLink;
        if( imageData != null ) {
            this.props.changeFieldValue( 'image', imageData );
            this.props.changeFieldValue( 'video_url', ytUrl );
        }
        this.setState( {
            selectedImage: imageData,
            showCoverModal: false,
        } );
    }
    updateUserSearch = ( e, { value } ) => {
        this.setState( {
            userSearch: value,
        } );
        debounce( 50, this.searchForUser( value ) );
    }
    searchForUser = ( name ) => {
        this.props.getUsers( {
            page: 1,
            limit: 4,
            sort: 'displayName,userid',
            usertype: 'verified creator',
            search: name || undefined,
        } )
        .then( ( users ) => {
            this.setState( { userOptions: users } );
        } );
    }
    selectUser = ( e, { result } ) => {
        var user = {
            displayName: result.title.replace( /^\d+:\s/, '' ),
            userid: result.value,
        };
        this.props.changeFieldValue( 'userid', user.userid );
        this.setState( { userSearch: user.displayName, userOptions: [] } );
    }
    catchKeyPress = ( e ) => {
        if( e.key == 'Enter' ) {
            e.preventDefault();
        }
    }
    cropFinish = ( imageData ) => {
        this.setState( {
            selectedImage: imageData,
        } );
        if( imageData != null ) {
            this.props.changeFieldValue( 'image', imageData );
        }
    }
    updateSponsored = ( event, { checked } ) => {
        this.setState( { isSponsored: checked } );
    }

    submit = ( values ) => {
        values.contentS3File = this.state.s3File;
        values.s3_file_id = this.state.s3File.id;
        values.vtt_s3_file_id = this.state.vTTS3File.id;
        values.image = this.state.selectedImage;
        values.isSponsored = this.state.isSponsored;
        this.props.next( values );
    }

    deleteHostedFile = async () => {
        try {
            await this.props.deleteFile(`/admin/files/${this.state.s3File.id}`);
            this.setState({ s3File: false });
        }
        catch(err) {
            console.log('ERR', err);
            alert('Error', err);
        }
    }

    deleteVTTFile = async () => {
        try {
            await this.props.deleteFile(`/admin/files/${this.state.vTTS3File.id}`);
            this.setState({ vTTS3File: false });
        }
        catch(err) {
            console.log('ERR', err);
            alert('Error', err);
        }
    }

    selectHostedFile = async (e) => {
        const files = e.target.files;
        const file = files[0];
        if (file == null) {
            return alert('No file selected.');
        }
        try {
            let cleanName = file.name.replace(/[^A-Z0-9.]/ig, '_');
            this.setState({ uploading: true });
            let response = await this.props.getSignedRequest({ name: cleanName });
            await this.props.uploadFile(response.signedRequest, file);
            let s3File = await this.props.createFileOnly({
                key: cleanName,
                type: file.type,
            });
            this.setState( { s3File: s3File } );
            this.setState( { uploading: false } );
            alert('The video file has been uploaded. Make sure to save/submit this form.');
        } catch (err) {
            this.setState({ uploading: false });
            alert('Error creating file', err);
        }
    }

    selectVTTFile = async (e) => {
        const files = e.target.files;
        const file = files[0];
        if (file == null) {
            return alert('No file selected.');
        }
        try {
            this.setState({ uploadingVTT: true });
            let response = await this.props.getSignedRequest({ name: file.name });
            await this.props.uploadFile(response.signedRequest, file);
            let s3File = await this.props.createFileOnly({
                key: file.name,
                type: file.type,
            });
            this.setState( { vTTS3File: s3File } );
            this.setState( { uploadingVTT: false } );
            alert('The vtt file has been uploaded. Make sure to save/submit this form.');
        } catch (err) {
            this.setState({ uploadingVTT: false });
            alert('Error creating file', err);
        }
    }


    render() {
        const { handleSubmit } = this.props;
        const { uploading, uploadingVTT, userSearch, userOptions, selectedImage } = this.state;

        const searchResults = userOptions.map( ( user ) => {
            return {
                title: `${ user.userid }: ${user.displayName}`,
                value: user.userid,
            };
        } );
        const showResults = searchResults.length > 0;
        return (
            <div>
                <Form
                className={ style.tagForm }
                onSubmit={ handleSubmit( this.submit ) }>

                    <div className={ style.imageWrapper } onClick={ () => { this.setState( { showCoverModal: true } ); } }>
                        <img src={ selectedImage } />
                        <br />
                        <span className={ style.editWrapper }><Edit style={ { display: 'inline-block' } } />Edit Image/Video</span>
                    </div>

                    <Field
                    name='title'
                    label='Title'
                    component={ FormTextField }
                    fullWidth />

                    <Field
                    name='review_text'
                    label='Text'
                    component={ FormTextArea }
                    fullWidth />

                    <Field
                    name='video_url'
                    label='Video URL'
                    component={ FormTextField }
                    fullWidth />

                    <div>
                        <label>Hosted Video File</label>
                        <br />
                        { !uploading && !this.state.s3File &&
                            <input type='file' name="s3_file" id="s3_file" onChange={ (e)=> { 
                                this.selectHostedFile(e);
                            } } />
                        }
                        { uploading == true &&
                            <>
                            Uploading...
                            </>
                        }
                        { !uploading && this.state.s3File &&
                            <>
                                <a onClick={ () => { this.deleteHostedFile(); } }> {this.state.s3File.key}<br />Delete Hosted File</a>
                                <video controls={true} src={ `https://d2220ok937f3dq.cloudfront.net/${this.state.s3File.key}` } width='200' />
                            </>
                        }
                        <br />
                        <br />
                    </div>

                    { this.state.s3File && 
                        <div>
                            <label>VTT File</label>
                            <br />
                            { !uploadingVTT && !this.state.vTTS3File &&
                                <input type='file' name="vtt_s3_file" id="vtt_s3_file" onChange={ (e)=> { 
                                    this.selectHostedFile(e, true);
                                } } />
                            }
                            { uploadingVTT == true &&
                                <>
                                Uploading...
                                </>
                            }
                            { !uploadingVTT && this.state.vTTS3File &&
                                <>
                                    <a onClick={ () => { this.deleteVTTFile(); } }> {this.state.vTTS3File.key}<br />Delete VTT File</a>
                                </>
                            }
                            <br />
                            <br />
                        </div>
                    }

                    <DLToggle
                    id='isSponsored'
                    name='isSponsored'
                    label='Sponsored Video?'
                    checked={ this.state.isSponsored }
                    onClick={ this.updateSponsored }
                    style={ { marginBottom: '15px' } } />

                    <div onKeyPress={ this.catchKeyPress }>
                        <DLAutoComplete
                        value={ userSearch }
                        label='Reviewing User*'
                        onChange={ this.updateUserSearch }
                        onResultSelect={ this.selectUser }
                        results={ searchResults }
                        open={ showResults }
                        maxLength='40'
                        fullWidth
                        style={ { marginTop: '7px' } } />
                    </div>

                    <PrimaryButton
                    label='Submit'
                    fullWidth
                    type='submit'
                    style={ { marginTop: '15px' } }/>
                </Form>
                { this.state.showCoverModal &&
                    <VideoImageSelector
                    initialValues={ { selectedImage: selectedImage, youtube: this.props.initialValues.video_url } }
                    closeHandler={ () => { this.setState( { showCoverModal: false } ); } }
                    onSubmit={ this.updateCover } />
                }
            </div>
        );
    }
}

ReviewForm = reduxForm( {
    form: 'ReviewForm',
} )( ReviewForm );

const mapDispatchToProps = ( dispatch ) => {
    return {
        getUsers: ( queryObject ) => {
            return dAPI.get( '/admin/users', queryObject );

        },
        changeFieldValue: ( field, value ) => {
            dispatch( change( 'ReviewForm', field, value ) );
        },
        getSignedRequest: ( queryObject ) => {
            return dAPI.get( '/admin/files/getsignedrequest', queryObject );
        },
        uploadFile: ( url, file ) => {
            return dAPI.put( url, file );
        },
        createFileOnly: ( queryObject ) => {
            return dAPI.post( '/admin/files/createfileonly', queryObject );
        },
        deleteFile: ( url ) => {
            return dAPI.delete( url );
        },
    };
};


export default connect( null, mapDispatchToProps )( ReviewForm );
